/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  TotalSalesReport,
} from '../models/index';
import {
    TotalSalesReportFromJSON,
    TotalSalesReportToJSON,
} from '../models/index';

/**
 * 
 */
export class TotalSalesResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getTotalSalesOfCurrentRetailer without sending the request
     */
    async getTotalSalesOfCurrentRetailerRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/totalsales`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getTotalSalesOfCurrentRetailerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TotalSalesReport>> {
        const requestOptions = await this.getTotalSalesOfCurrentRetailerRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TotalSalesReportFromJSON(jsonValue));
    }

    /**
     */
    async getTotalSalesOfCurrentRetailer(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TotalSalesReport> {
        const response = await this.getTotalSalesOfCurrentRetailerRaw(initOverrides);
        return await response.value();
    }

}
